import React, { useEffect, useState } from "react";

import { useGetCurrentUser } from "api/api-hooks/user-hooks";
import { TabMenu } from "primereact/tabmenu";
import { Outlet, useNavigate } from "react-router-dom";
import ProjectDropDown from "./ProjectDropDown";

const Layout = () => {
  const [activeIndex, setActiveIndex] = useState(2);
  const [projectId, setProjectId] = useState<string | null>(null);
  const {data: userData} = useGetCurrentUser();

  useEffect(() => {
    const { hash } = window.location;
    if (hash === "#/" || hash === "") return setActiveIndex(0);
    if (hash === "#/devices") return setActiveIndex(1);
    if (hash === "#/analytics") return setActiveIndex(2);
    if (hash === "#/map") return setActiveIndex(3);
    if (hash === "#/settings") return setActiveIndex(4);
    return setActiveIndex(10);
  }, [window.location.hash]);
  
  const navigate = useNavigate();
  const items = [
    {
      label: "Objects",
      icon: "pi pi-list",
      command: () => {
        navigate("/");
      },
    },
    {
      label: "Devices",
      icon: "pi pi-list",
      command: () => {
        navigate("/devices");
      },
    },
    {
      label: "Analytics",
      icon: "pi pi-chart-line",
      command: () => {
        navigate("/analytics");
      },
    },
    {
      label: "Map",
      icon: "pi pi-map",
      command: () => {
        navigate("/map");
      },
    },
    {
      label: "Settings",
      icon: "pi pi-cog",
      command: () => {
        navigate("/settings");
      },
    },
  ];

  return (
    <div>
      <div className="flex gap-1">
        <TabMenu
          model={items}
          className="flex-1 justify-content-end"
          activeIndex={activeIndex}
          onTabChange={e => setActiveIndex(e.index)}
        />
        {userData?.companyRef && (
          <ProjectDropDown
            companyRef={userData.companyRef}
            projectId={projectId}
            setProjectId={setProjectId}
          />
        )}
      </div>
      <Outlet context={projectId} />
    </div>
  );
};

export default Layout;
